import React from "react";
import { Box, Button, CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";

interface DeleteCmsItemDialogProps {
  open: boolean;
  itemName?: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export default function DeleteCmsItemDialog({
  open,
  itemName,
  onClose,
  onConfirm,
  isDeleting = false,
}: DeleteCmsItemDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogContent sx={{ p: 4 }}>
        <Typography variant="h6" fontWeight={600} textAlign="center" mb={1}>
          Delete Item?
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          This action cannot be undone.
        </Typography>
        {itemName && (
          <Typography variant="subtitle1" fontWeight={600} textAlign="center" mt={2}>
            {itemName}
          </Typography>
        )}
        <Box display="flex" justifyContent="center" gap={2} mt={4}>
          <Button onClick={onClose} disabled={isDeleting} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isDeleting}
            variant="contained"
            color="error"
            sx={{ minWidth: 140 }}
          >
            {isDeleting ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={16} color="inherit" />
                Deleting
              </Box>
            ) : (
              "Delete"
            )}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
